import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CompanyProfile } from 'app/shared/types/company-profile';
import { CompanyProfileService } from 'app/shared/services/company-profile.service';
import { DialogService } from 'app/shared/services/dialog.service';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'app/shared/services/auth.service';
import { FileUploadService } from 'app/shared/services/file-upload.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import { NbThemeService } from '@nebular/theme';
import { FileUploadComponent } from '../../file-upload/file-upload.component';



@Component({
  selector: 'app-company-profile',
  templateUrl: './company-profile.component.html',
  styleUrls: ['./company-profile.component.css']
})
export class CompanyProfileComponent implements OnInit {

  companyProfile: CompanyProfile;
  companyProfileForm: FormGroup;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;
  isShowAttachBtn: boolean=false;
  
  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };
 

  isDark: boolean = false;

  validationMessages = {
    'comName': { 'required': 'Company name is required' },
    'address': { 'required': 'Address is required' },
    'phone': { 'required': 'Phone Number is required' },
    'email': {'email': 'Email must be a valid email address'},   
  };

  formErrors = {
    'comName': "",
    'address': "",
    'phone': "",
    'email': "",
  };



  constructor(
              private fb: FormBuilder,
              private companyProfileService: CompanyProfileService,
              private toastr: ToastrService,
              private router : Router, 
              private authService: AuthService,
              private themeService: NbThemeService,
              private fileUploadService:FileUploadService,
              private dialogService: DialogService,
              ) 
              {  } // end constructor


  ngOnInit() {

    this.companyProfile = {
      companyCode : null,
      companyName : '',
      regNo : '',
      taxNo : '',
      svatNo : '',
      mobileNo : '',
      phone : '',
      fax : '',
      email : '',
      web : '',
      address : '',
      deliveryAddress : '',
      createdBy : ''
  
    }

    this.companyProfileForm = this.fb.group({
      comCode : [null],
      comName : ['', Validators.required],
      regNo : [''],   
      taxNo : [''],
      svatNo : [''],
      mobileNo : [''],
      phone : ['', Validators.required],
      fax : [''],
      email : ['', [Validators.email]],
      web : [''],
      address : ['', Validators.required],
      deliveryAddress : [''],
      createdBy : [''],

    });

    this.getCompanyDetails();
    this.getControlPermissions();


  this.themeService.onThemeChange()
  .subscribe(themeName =>{
       this.isDark  = themeName.name ==='dark' ? true : false;
     });

  } //end oninit


  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='COM'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }

  attachFileButtonClick(){
    this.fileUploadService.refNo = this.companyProfileForm.value.comCode;
     const dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = true;
     dialogConfig.width = "75%";
     this.dialogService.openDialog(FileUploadComponent,dialogConfig);
        
    }
  

  saveButtonClick(): void {

    this.showProcessingIndicator = true;
    this.logValidationErrors(this.companyProfileForm,true);
    this.mapFormValuesToCompanyProfileModel();  

          if(this.isFilledFromFields()){
              this.companyProfileService.updateCompany(this.companyProfile)
              .subscribe(
                (res) => {
                            this.toastr.success('Company details updated','Success');   
                            this.isShowAttachBtn = true;                          
                            this.showProcessingIndicator = false;                           
                          },        
                (err) =>  {
                            this.toastr.error('Failed to add Company details','Failure');                            
                            this.showProcessingIndicator = false;
                            if(err instanceof HttpErrorResponse){                 
                              if(err.status == 401){
                                this.router.navigate(['/login']);
                              }
                            }
                            console.log(err);
                          }, 
                )

                                              
          }
          else{
            this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
            this.showProcessingIndicator = false;          
          } 
                  
   }



   enableForm():void{
    Object.keys(this.companyProfileForm.controls).forEach(key => {
      this.companyProfileForm.controls[key].enable();
      //console.log(key)
    });
  }

  
  logValidationErrors(group: FormGroup = this.companyProfileForm,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if(isDirty)
      {
        this.enableForm();
        this.companyProfileForm.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }


  isFilledFromFields() : boolean {
    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
          return false;
        }
        return true;
}

 mapFormValuesToCompanyProfileModel(){
    this.companyProfile.companyName=this.companyProfileForm.value.comName;
    this.companyProfile.regNo=this.companyProfileForm.value.regNo;
    this.companyProfile.taxNo=this.companyProfileForm.value.taxNo;
    this.companyProfile.svatNo=this.companyProfileForm.value.svatNo;
    this.companyProfile.mobileNo=this.companyProfileForm.value.mobileNo;
    this.companyProfile.phone=this.companyProfileForm.value.phone;
    this.companyProfile.fax=this.companyProfileForm.value.fax;
    this.companyProfile.email=this.companyProfileForm.value.email;
    this.companyProfile.web=this.companyProfileForm.value.web;
    this.companyProfile.address=this.companyProfileForm.value.address;
    this.companyProfile.deliveryAddress=this.companyProfileForm.value.deliveryAddress;  
    this.companyProfile.createdBy= this.authService.getUserLoggedIn();

  }

  getCompanyDetails(){
    var companyData;
    this.companyProfileService.getCompanyDetails()
    .subscribe(
      (data) =>{
                companyData = data[0];

                this.companyProfileForm.patchValue({
                  comCode : companyData.CompanyCode,
                  comName : companyData.CompanyName,
                  regNo :companyData.RegNo,
                  taxNo : companyData.TaxNo,
                  svatNo : companyData.SVATNo,
                  mobileNo : companyData.MobileNo,
                  phone : companyData.Phone,
                  fax : companyData.Fax,
                  email : companyData.Email,
                  web : companyData.Web,
                  address : companyData.Address,
                  deliveryAddress : companyData.DeliveryAddress,                
                })
             
                this.isShowAttachBtn = true;
                },
      (err) => {
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
             }
    );
  
  }




} //end class
